import React from 'react';
import {
  FDBodyText,
  FDPaper,
  FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import UploadGroupItem from './UploadGroupItem';

const accountMetaOverrideSet = buildFacetDesignOverride()
  .nameOverride('description', {
    _component: () => FDBodyText,
  }, overrideReadOnly)
  .done();

const UploadGroup = () => {
  const { resource } = useMetaLayoutContext();

  if (!resource) {
    return null;
  }

  return (
    <FDPaper {...dataAttrs('upload-group', resource)}>
      <FDStack direction="column" spacing={1} padding={2} width="100%">
        <FDStack direction="row" flex={1} justifyContent={'flex-start'}>
          <MetaControlField attr={'name'} />
        </FDStack>
        <FDStack direction="column" spacing={0} flex={1.5}>
          <MetaCollectionRenderer
            collection={resource.attr('items')}
            layout={UploadGroupItem}
            metaOverrideSet={accountMetaOverrideSet}
            {...dataAttrs('upload-group-items', resource)}
          />
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};

UploadGroup.propTypes = {};

UploadGroup.defaultProps = {};

export default UploadGroup;
